(function (window, document) {
  "use strict";

  var DNB = (window.DNB = window.DNB || {});

  DNB.CmsTimeline = {
    init: function () {
      var roots = document.querySelectorAll("[data-cms-timeline]");
      if (!roots.length) return;

      Array.prototype.forEach.call(roots, function (root) {
        if (root.getAttribute("data-cms-timeline-init") === "1") return;
        var items = Array.prototype.slice.call(root.querySelectorAll("[data-cms-timeline-item]"));
        if (!items.length) return;
        root.setAttribute("data-cms-timeline-init", "1");
        bind(root, items);
      });
    }
  };

  function bind(root, items) {
    var rail = document.createElement("div");
    rail.className = "cms-timeline__rail";
    rail.innerHTML =
      '<span class="cms-timeline__bar" aria-hidden="true"></span>' +
      '<span class="cms-timeline__progress" data-cms-timeline-progress></span>' +
      '<span class="cms-timeline__badge" data-cms-timeline-badge hidden></span>';
    root.insertBefore(rail, root.firstChild);

    var progress = rail.querySelector("[data-cms-timeline-progress]");
    var badge = rail.querySelector("[data-cms-timeline-badge]");
    var positions = [];
    var dots = [];
    var hoverIndex = -1;
    var scrollIndex = 0;
    var scrollPx = 0;
    var mq = window.matchMedia("(max-width: 1024px)");

    items.forEach(function (item, index) {
      var yearEl = item.querySelector(".cms-timeline__year");
      var year = yearEl ? yearEl.textContent.replace(/\s+/g, " ").trim() : "";
      var dot = document.createElement("button");
      dot.type = "button";
      dot.className = "cms-timeline__dot";
      dot.setAttribute("data-cms-timeline-dot", "");
      dot.setAttribute("data-index", String(index));
      dot.setAttribute("aria-label", year);
      dot.addEventListener("click", function () {
        var header = document.querySelector(".site-header");
        var offset = header ? header.offsetHeight + 24 : 24;
        var top = item.getBoundingClientRect().top + window.scrollY - offset;
        if (DNB.ScrollService && typeof DNB.ScrollService.scrollTo === "function") {
          DNB.ScrollService.scrollTo(top);
        } else {
          window.scrollTo({ top: top, behavior: "smooth" });
        }
      });
      rail.appendChild(dot);
      dots.push(dot);
    });

    function measure() {
      var railTop = rail.getBoundingClientRect().top;
      positions = items.map(function (item) {
        return item.getBoundingClientRect().top - railTop;
      });
      dots.forEach(function (dot, index) {
        dot.style.top = positions[index] + "px";
      });
    }

    function readScroll() {
      var trigger = Math.min(window.innerHeight * 0.38, 320);
      if (mq.matches) {
        scrollIndex = 0;
        items.forEach(function (item, i) {
          if (item.getBoundingClientRect().top <= trigger) scrollIndex = i;
        });
        return;
      }
      var y = trigger - rail.getBoundingClientRect().top;
      var max = rail.offsetHeight;
      if (y < 0) y = 0;
      if (y > max) y = max;
      scrollPx = y;
      scrollIndex = 0;
      for (var i = 0; i < positions.length; i++) {
        if (positions[i] <= y + 1) scrollIndex = i;
      }
    }

    function render(animate) {
      var index = hoverIndex >= 0 ? hoverIndex : scrollIndex;
      var px = hoverIndex >= 0 ? positions[hoverIndex] : scrollPx;
      if (px == null || isNaN(px)) px = 0;
      progress.style.transition = animate ? "height 0.45s ease" : "none";
      progress.style.height = px + "px";

      items.forEach(function (item, i) {
        item.classList.toggle("is-active", i === index);
      });
      dots.forEach(function (dot, i) {
        dot.classList.toggle("is-reached", positions[i] <= px + 1);
      });

      var yearEl = items[index] && items[index].querySelector(".cms-timeline__year");
      if (!yearEl || mq.matches) {
        badge.hidden = true;
        return;
      }
      badge.hidden = false;
      badge.textContent = yearEl.textContent.replace(/\s+/g, " ").trim();
      badge.style.transition = animate ? "top 0.45s ease" : "top 0.35s ease";
      badge.style.top = (positions[index] + 8) + "px";
    }

    function onScroll() {
      if (mq.matches) {
        readScroll();
        render(false);
        return;
      }
      measure();
      readScroll();
      if (hoverIndex < 0) render(false);
    }

    root.addEventListener("mouseover", function (event) {
      if (mq.matches) return;
      var item = event.target.closest("[data-cms-timeline-item]");
      var dot = event.target.closest("[data-cms-timeline-dot]");
      var index = -1;
      if (item) index = items.indexOf(item);
      else if (dot) index = Number(dot.getAttribute("data-index"));
      if (index < 0 || index === hoverIndex) return;
      hoverIndex = index;
      render(true);
    });

    root.addEventListener("mouseleave", function () {
      if (hoverIndex < 0) return;
      hoverIndex = -1;
      render(true);
    });

    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
    if (DNB.onScrollReady) {
      DNB.onScrollReady(function () {
        if (DNB.ScrollService && DNB.ScrollService.lenis) {
          DNB.ScrollService.lenis.on("scroll", onScroll);
        }
      });
    }

    measure();
    readScroll();
    render(false);
  }
})(window, document);
